import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const BottomNav = () => {
  const location = useLocation();
  const isAdmin = location.pathname.includes('/admin');

  if (isAdmin) return null;

  const navItems = [
    { path: '/', icon: 'Home', label: 'Home' },
    { path: '/news', icon: 'FileText', label: 'News' },
    { path: '/tools', icon: 'Box', label: 'Tools' },
    { path: '/threads', icon: 'TrendingUp', label: 'Threads' },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-brand-surface border-t border-brand-border pb-[env(safe-area-inset-bottom)]">
      <div className="flex justify-around items-center h-20 px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link 
              key={item.label} 
              to={item.path} 
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className={`flex flex-col items-center justify-center w-full h-full space-y-1.5 ${
                isActive ? 'text-brand-text' : 'text-brand-muted hover:text-brand-secondary'
              }`}
            >
              <SafeIcon icon={item.icon} className="w-6 h-6" />
              <span className={`text-[12px] font-bold ${isActive ? 'underline underline-offset-4 decoration-2 decoration-brand-text' : ''}`}>{item.label}</span>
            </Link>
          )
        })}
      </div>
    </div>
  );
};

export default BottomNav;